import { formatHtml } from "utils/format";

class DataClass {
  statTypes = {
    38: {
      tip: 'tip.name.tooptip_addon_lifecasting_speed',
      decimal: 2,
    },
    39: {
      tip: 'tip.name.tooptip_addon_lifecasting_tier',
    },
    40: {
      tip: 'tip.name.enum_addontype_life_bonus_type_success',
      prepend: [
        'tip.name.enum_professiontype_na',
        'tip.name.enum_professiontype_herbalism',
        'tip.name.enum_professiontype_lumbering',
        'tip.name.enum_professiontype_mining',
        'tip.name.enum_professiontype_hunting',
        'tip.name.enum_professiontype_fishing',
        'tip.name.enum_professiontype_archaeology',
      ],
      decimal: 2,
    },
    41: {
      tip: 'tip.name.tooptip_addon_lifedrop_bonusrate_extra',
      decimal: 2,
    },
    42: {
      tip: 'tip.name.tooptip_addon_lifedrop_bonusrate_skillbonus',
      decimal: 2,
    },
    43: {
      tip: 'tip.name.tooptip_addon_lifedrop_bonusrate_minigameperfect',
      decimal: 2,
    },
    44: {
      tip: 'tip.name.tooptip_addon_lifedurability_bonus',
      decimal: 2,
    },
    45: {
      tip: 'tip.name.tooptip_addon_minigame_difficulty',
    },
  };
  
  featureTypes = {
    294: {
      tip: 'tip.name.enum_abilityfeaturetype_life_herbalism_super_armor',
    },
    295: {
      tip: 'tip.name.enum_abilityfeaturetype_life_lumbering_super_armor',
    },
    296: {
      tip: 'tip.name.enum_abilityfeaturetype_life_mining_super_armor',
    },
    297: {
      tip: 'tip.name.enum_abilityfeaturetype_life_hunting_super_armor',
    },
    298: {
      tip: 'tip.name.enum_abilityfeaturetype_life_fishing_super_armor',
    },
    299: {
      tip: 'tip.name.enum_abilityfeaturetype_life_archaeology_super_armor',
    },
    320: {
      tip: 'tip.name.enum_abilityfeaturetype_voyage_ship_repair_charge_reduce',
      decimal: 2,
    },
    321: {
      tip: 'tip.name.enum_abilityfeaturetype_life_all_mastery_level',
    },
    322: {
      tip: 'tip.name.enum_abilityfeaturetype_life_all_profession_condition_level',
    },
  };
  
  classMap = {
    101: 'warrior',
    102: 'berserker',
    103: 'destroyer',
    104: 'warlord',
    105: 'holyknight',

    111: 'warrior_female',
    112: 'berserker_female',
  
    201: 'magician',
    202: 'arcana',
    203: 'summoner',
    204: 'bard',
    205: 'elementalmaster',

    301: 'fighter',
    302: 'battlemaster',
    303: 'infighter',
    304: 'forcemaster',
    305: 'lancemaster',

    311: 'fighter_male',
    312: 'battlemaster_male',

    401: 'delain',
    402: 'blade',
    403: 'demonic',
    404: 'reaper',
  
    501: 'hunter',
    502: 'hawkeye',
    503: 'devilhunter',
    504: 'blaster',
    505: 'scouter',

    511: 'hunter_female',
    512: 'devilhunter_female',
  
    601: 'specialist',
    602: 'yinyangshi',
    603: 'weatherartist',
  };
  
  playerClasses = {
    warrior: {
      name: 'tip.name.enum_playerclass_warrior',
    },
    warlord: {
      name: 'tip.name.enum_playerclass_warlord',
      parent: 'warrior',
    },
    holyknight: {
      name: 'tip.name.enum_playerclass_holyknight',
      parent: 'warrior',
    },
    berserker: {
      name: 'tip.name.enum_playerclass_berserker',
      parent: 'warrior',
    },
    destroyer: {
      name: 'tip.name.enum_playerclass_destroyer',
      parent: 'warrior',
    },
    warrior_female: {
      name: 'tip.name.enum_playerclass_warrior_female',
    },
    berserker_female: {
      name: 'tip.name.enum_playerclass_berserker_female',
      parent: 'warrior_female',
    },
    fighter: {
      name: 'tip.name.enum_playerclass_fighter',
    },
    battlemaster: {
      name: 'tip.name.enum_playerclass_battle_master',
      parent: 'fighter',
    },
    infighter: {
      name: 'tip.name.enum_playerclass_infighter',
      parent: 'fighter',
    },
    forcemaster: {
      name: 'tip.name.enum_playerclass_force_master',
      parent: 'fighter',
    },
    lancemaster: {
      name: 'tip.name.enum_playerclass_lance_master',
      parent: 'fighter',
    },
    fighter_male: {
      name: 'tip.name.enum_playerclass_fighter_male',
    },
    battlemaster_male: {
      name: 'tip.name.enum_playerclass_battle_master_male',
      parent: 'fighter_male',
    },
    hunter: {
      name: 'tip.name.enum_playerclass_hunter',
    },
    devilhunter: {
      name: 'tip.name.enum_playerclass_devil_hunter',
      parent: 'hunter',
    },
    blaster: {
      name: 'tip.name.enum_playerclass_blaster',
      parent: 'hunter',
    },
    hawkeye: {
      name: 'tip.name.enum_playerclass_hawk_eye',
      parent: 'hunter',
    },
    scouter: {
      name: 'tip.name.enum_playerclass_scouter',
      parent: 'hunter',
    },
    hunter_female: {
      name: 'tip.name.enum_playerclass_hunter_female',
    },
    devilhunter_female: {
      name: 'tip.name.enum_playerclass_devil_hunter_female',
      parent: 'hunter_female',
    },
    magician: {
      name: 'tip.name.enum_playerclass_magician',
    },
    arcana: {
      name: 'tip.name.enum_playerclass_arcana',
      parent: 'magician',
    },
    bard: {
      name: 'tip.name.enum_playerclass_bard',
      parent: 'magician',
    },
    summoner: {
      name: 'tip.name.enum_playerclass_summoner',
      parent: 'magician',
    },
    elementalmaster: {
      name: 'tip.name.enum_playerclass_elemental_master',
      parent: 'magician',
    },
    delain: {
      name: 'tip.name.enum_playerclass_delain',
    },
    blade: {
      name: 'tip.name.enum_playerclass_blade',
      parent: 'delain',
    },
    demonic: {
      name: 'tip.name.enum_playerclass_demonic',
      parent: 'delain',
    },
    reaper: {
      name: 'tip.name.enum_playerclass_reaper',
      parent: 'delain',
    },
    specialist: {
      name: 'tip.name.enum_playerclass_specialist',
    },
    yinyangshi: {
      name: 'tip.name.enum_playerclass_yinyangshi',
      parent: 'specialist',
    },
    weatherartist: {
      name: 'tip.name.enum_playerclass_weather_artist',
      parent: 'specialist',
    },
    // astrologer: {
    //   name: 'tip.name.enum_playerclass_astrologer',
    //   parent: 'specialist',
    // },
  };
  
  itemGrades = [
    {
      name: 'tip.name.enum_itemgrade_common',
      color: 'common',
    },
    {
      name: 'tip.name.enum_itemgrade_uncommon',
      color: 'uncommon',
    },
    {
      name: 'tip.name.enum_itemgrade_rare',
      color: 'rare',
    },
    {
      name: 'tip.name.enum_itemgrade_epic',
      color: 'epic',
    },
    {
      name: 'tip.name.enum_itemgrade_legend',
      color: 'legendary',
    },
    {
      name: 'tip.name.enum_itemgrade_relic',
      color: 'relic',
    },
    {
      name: 'tip.name.enum_itemgrade_ancient',
      color: 'ancient',
    },
    {
      name: 'tip.name.enum_itemgrade_esther',
      color: 'esther',
    },
    {
      name: 'tip.name.enum_itemgrade_ancient',
      color: 'ancient',
    },
    {
      name: 'tip.name.enum_itemgrade_quest',
      color: 'uncommon',
    },
  ];
  
  itemCategory = {
    10101: {
      name: 'tip.name.enum_itemcategory_equip_weapon_sword',
      slot: 'weapon',
    },
    10102: {
      name: 'tip.name.enum_itemcategory_equip_weapon_hammer',
      slot: 'weapon',
    },
    10103: {
      name: 'tip.name.enum_itemcategory_equip_weapon_gunlance',
      slot: 'weapon',
    },
    10104: {
      name: 'tip.name.enum_itemcategory_equip_weapon_bow',
      slot: 'weapon',
    },
    10105: {
      name: 'tip.name.enum_itemcategory_equip_weapon_gun',
      slot: 'weapon',
    },
    10106: {
      name: 'tip.name.enum_itemcategory_equip_weapon_launcher',
      slot: 'weapon',
    },
    10107: {
      name: 'tip.name.enum_itemcategory_equip_weapon_triple_sword',
      slot: 'weapon',
    },
    10111: {
      name: 'tip.name.enum_itemcategory_equip_weapon_staff2',
      slot: 'weapon',
    },
    10112: {
      name: 'tip.name.enum_itemcategory_equip_weapon_liana_harp',
      slot: 'weapon',
    },
    10113: {
      name: 'tip.name.enum_itemcategory_equip_weapon_heavy_gauntlet',
      slot: 'weapon',
    },
    10114: {
      name: 'tip.name.enum_itemcategory_equip_weapon_symbol',
      slot: 'weapon',
    },
    10115: {
      name: 'tip.name.enum_itemcategory_equip_weapon_element',
      slot: 'weapon',
    },
    10116: {
      name: 'tip.name.enum_itemcategory_equip_weapon_tarot_card',
      slot: 'weapon',
    },
    10119: {
      name: 'tip.name.enum_itemcategory_equip_weapon_sub_machine_gun',
      slot: 'weapon',
    },
    10120: {
      name: 'tip.name.enum_itemcategory_equip_weapon_lance',
      slot: 'weapon',
    },
    10121: {
      name: 'tip.name.enum_itemcategory_equip_weapon_dual_sword',
      slot: 'weapon',
    },
    10122: {
      name: 'tip.name.enum_itemcategory_equip_weapon_demonic_weapon',
      slot: 'weapon',
    },
    10123: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_holy_sword',
    },
    10124: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_dagger',
    },
    10125: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_gun_female',
    },
    10126: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_element_male',
    },
    10127: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_giant_staff',
    },
    10128: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_pen',
    },
    10129: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_umbrella',
    },
    10130: {
      slot: 'weapon',
      name: 'tip.name.enum_itemcategory_equip_weapon_sword_female',
    },
    10201: {
      name: 'tip.name.enum_itemcategory_equip_armor_helmet',
      slot: 'head',
    },
    10202: {
      name: 'tip.name.enum_itemcategory_equip_armor_top',
      slot: 'torso',
    },
    10203: {
      name: 'tip.name.enum_itemcategory_equip_armor_pants',
      slot: 'legs',
    },
    10204: {
      name: 'tip.name.enum_itemcategory_equip_armor_glove',
      slot: 'hands',
    },
    10205: {
      name: 'tip.name.enum_itemcategory_equip_armor_pauldron',
      slot: 'shoulders',
    },
    10401: {
      name: 'tip.name.enum_itemcategory_equip_accessory_necklace',
      slot: 'necklace',
    },
    10402: {
      name: 'tip.name.enum_itemcategory_equip_accessory_earring',
      slot: 'earring',
    },
    10403: {
      name: 'tip.name.enum_itemcategory_equip_accessory_ring',
      slot: 'ring',
    },
    10404: {
      name: 'tip.name.enum_itemcategory_equip_accessory_ring',
      slot: 'bracelet',
    },
    10500: {
      name: 'tip.name.enum_itemcategory_equip_ability_stone',
      slot: 'stone',
    },
    10601: {
      name: 'tip.name.enum_itemcategory_equip_assistance_voyage',
      slot: 'assistance_voyage',
    },
    10602: {
      name: 'tip.name.enum_itemcategory_equip_assistance_life',
      slot: 'assistance_life',
    },
    10603: {
      name: 'tip.name.enum_itemcategory_equip_assistance_combat',
      slot: 'assistance_combat',
    },
  };
  
  itemSplits = [
    811016,
    40112291,
    101200340,
    103100496,
    104300836,
    111023334,
    113344133,
    122000237,
    132000060,
    141000746,
    151000470,
    200020722,
    304190073,
    315090038,
    331000088,
    Infinity,
  ];
  
  itemStats = {
    hp: { tip: 'tip.name.enum_stattype_hp', id: 1 },
    mp: { tip: 'tip.name.enum_stattype_mp', id: 2 },
    str: { tip: 'tip.name.enum_stattype_str', id: 3 },
    agi: { tip: 'tip.name.enum_stattype_agi', id: 4 },
    int: { tip: 'tip.name.enum_stattype_int', id: 5 },
    con: { tip: 'tip.name.enum_stattype_con', id: 6 },
    str_x: { tip: 'tip.name.enum_stattype_str_x', decimal: 2, percent: true, id: 7 },
    agi_x: { tip: 'tip.name.enum_stattype_agi_x', decimal: 2, percent: true, id: 8 },
    int_x: { tip: 'tip.name.enum_stattype_int_x', decimal: 2, percent: true, id: 9 },
    con_x: { tip: 'tip.name.enum_stattype_con_x', decimal: 2, percent: true, id: 10 },
    criticalhit: { tip: 'tip.name.enum_stattype_criticalhit', id: 15 },
    specialty: { tip: 'tip.name.enum_stattype_specialty', id: 16 },
    oppression: { tip: 'tip.name.enum_stattype_oppression', id: 17 },
    rapidity: { tip: 'tip.name.enum_stattype_rapidity', id: 18 },
    endurance: { tip: 'tip.name.enum_stattype_endurance', id: 19 },
    mastery: { tip: 'tip.name.enum_stattype_mastery', id: 20 },
    criticalhit_x: { tip: 'tip.name.enum_stattype_criticalhit_x', decimal: 2, percent: true, id: 21 },
    specialty_x: { tip: 'tip.name.enum_stattype_specialty_x', decimal: 2, percent: true, id: 22 },
    oppression_x: { tip: 'tip.name.enum_stattype_oppression_x', decimal: 2, percent: true, id: 23 },
    rapidity_x: { tip: 'tip.name.enum_stattype_rapidity_x', decimal: 2, percent: true, id: 24 },
    endurance_x: { tip: 'tip.name.enum_stattype_endurance_x', decimal: 2, percent: true, id: 25 },
    mastery_x: { tip: 'tip.name.enum_stattype_mastery_x', decimal: 2, percent: true, id: 26 },
    max_hp: { tip: 'tip.name.enum_stattype_max_hp', id: 27 },
    max_mp: { tip: 'tip.name.enum_stattype_max_mp', id: 28 },
    max_hp_x: { tip: 'tip.name.enum_stattype_max_hp_x', decimal: 2, percent: true, id: 29 },
    max_mp_x: { tip: 'tip.name.enum_stattype_max_mp_x', decimal: 2, percent: true, id: 30 },
    normal_hp_recovery: { tip: 'tip.name.enum_stattype_normal_hp_recovery', id: 33 },
    combat_hp_recovery: { tip: 'tip.name.enum_stattype_combat_hp_recovery', id: 34 },
    normal_hp_recovery_rate: { tip: 'tip.name.enum_stattype_normal_hp_recovery_rate', decimal: 2, percent: true, id: 35 },
    combat_hp_recovery_rate: { tip: 'tip.name.enum_stattype_combat_hp_recovery_rate', decimal: 2, percent: true, id: 36 },
    normal_mp_recovery: { tip: 'tip.name.enum_stattype_normal_mp_recovery', id: 37 },
    combat_mp_recovery: { tip: 'tip.name.enum_stattype_combat_mp_recovery', id: 38 },
    normal_mp_recovery_rate: { tip: 'tip.name.enum_stattype_normal_mp_recovery_rate', decimal: 2, percent: true, id: 39 },
    combat_mp_recovery_rate: { tip: 'tip.name.enum_stattype_combat_mp_recovery_rate', decimal: 2, percent: true, id: 40 },
    self_recovery_rate: { tip: 'tip.name.enum_stattype_self_recovery_rate', decimal: 2, percent: true, id: 41 },
    drain_hp_dam_rate: { tip: 'tip.name.enum_stattype_drain_hp_dam_rate', decimal: 2, percent: true, id: 42 },
    drain_mp_dam_rate: { tip: 'tip.name.enum_stattype_drain_mp_dam_rate', decimal: 2, percent: true, id: 43 },
    dam_reflection_rate: { tip: 'tip.name.enum_stattype_dam_reflection_rate', decimal: 2, percent: true, id: 44 },
    char_attack_dam: { tip: 'tip.name.enum_stattype_char_attack_dam', id: 47 },
    attack_power_rate: { tip: 'tip.name.enum_stattype_attack_power_rate', decimal: 2, percent: true, id: 49 },
    damagerate: { tip: 'tip.name.enum_stattype_skill_damage_rate', decimal: 2, percent: true, id: 50 },
    cooldown_reduction: { tip: 'tip.name.enum_stattype_cooldown_reduction', decimal: 2, percent: true, id: 53 },
    paralyzation_point_rate: { tip: 'tip.name.enum_stattype_paralyzation_point_rate', decimal: 2, percent: true, id: 54 },
    def: { tip: 'tip.name.enum_stattype_def', id: 55 },
    res: { tip: 'tip.name.enum_stattype_res', id: 56 },
    def_x: { tip: 'tip.name.enum_stattype_def_x', decimal: 2, percent: true, id: 57 },
    res_x: { tip: 'tip.name.enum_stattype_res_x', decimal: 2, percent: true, id: 58 },
    def_pen_rate: { tip: 'tip.name.enum_stattype_def_pen_rate', decimal: 2, percent: true, id: 67 },
    res_pen_rate: { tip: 'tip.name.enum_stattype_res_pen_rate', decimal: 2, percent: true, id: 68 },
    physical_inc_rate: { tip: 'tip.name.enum_stattype_physical_inc_rate', decimal: 2, percent: true, id: 69 },
    magical_inc_rate: { tip: 'tip.name.enum_stattype_magical_inc_rate', decimal: 2, percent: true, id: 70 },
    self_shield_rate: { tip: 'tip.name.enum_stattype_self_shield_rate', decimal: 2, percent: true, id: 71 },
    hit_rate: { tip: 'tip.name.enum_stattype_hit_rate', decimal: 2, percent: true, id: 72 },
    dodge_rate: { tip: 'tip.name.enum_stattype_dodge_rate', decimal: 2, percent: true, id: 73 },
    critical_hit_rate: { tip: 'tip.name.enum_stattype_critical_hit_rate', decimal: 2, percent: true, id: 74 },
    critical_res_rate: { tip: 'tip.name.enum_stattype_critical_res_rate', decimal: 2, percent: true, id: 75 },
    critical_dam_rate: { tip: 'tip.name.enum_stattype_critical_dam_rate', decimal: 2, percent: true, id: 76 },
    attack_speed: { tip: 'tip.name.enum_stattype_attack_speed', decimal: 1, id: 77 },
    attack_speed_rate: { tip: 'tip.name.enum_stattype_attack_speed_rate', decimal: 2, percent: true, id: 78 },
    move_speed: { tip: 'tip.name.enum_stattype_move_speed', decimal: 1, id: 79 },
    move_speed_rate: { tip: 'tip.name.enum_stattype_move_speed_rate', decimal: 2, percent: true, id: 80 },
    prop_move_speed: { tip: 'tip.name.enum_stattype_prop_move_speed', decimal: 1, id: 81 },
    prop_move_speed_rate: { tip: 'tip.name.enum_stattype_prop_move_speed_rate', decimal: 2, percent: true, id: 82 },
    vehicle_move_speed: { tip: 'tip.name.enum_stattype_vehicle_move_speed', decimal: 1, id: 83 },
    vehicle_move_speed_rate: { tip: 'tip.name.enum_stattype_vehicle_move_speed_rate', decimal: 2, percent: true, id: 84 },
    ship_move_speed: { tip: 'tip.name.enum_stattype_ship_move_speed', decimal: 1, id: 85 },
    ship_move_speed_rate: { tip: 'tip.name.enum_stattype_ship_move_speed_rate', decimal: 2, percent: true, id: 86 },
    fire_dam_rate: { tip: 'tip.name.enum_stattype_fire_dam_rate', decimal: 2, percent: true, id: 87 },
    ice_dam_rate: { tip: 'tip.name.enum_stattype_ice_dam_rate', decimal: 2, percent: true, id: 88 },
    electricity_dam_rate: { tip: 'tip.name.enum_stattype_electricity_dam_rate', decimal: 2, percent: true, id: 89 },
    earth_dam_rate: { tip: 'tip.name.enum_stattype_earth_dam_rate', decimal: 2, percent: true, id: 91 },
    dark_dam_rate: { tip: 'tip.name.enum_stattype_dark_dam_rate', decimal: 2, percent: true, id: 92 },
    holy_dam_rate: { tip: 'tip.name.enum_stattype_holy_dam_rate', decimal: 2, percent: true, id: 93 },
    elements_dam_rate: { tip: 'tip.name.enum_stattype_elements_dam_rate', decimal: 2, percent: true, id: 94 },
    fire_res_rate: { tip: 'tip.name.enum_stattype_fire_res_rate', decimal: 2, percent: true, id: 95 },
    ice_res_rate: { tip: 'tip.name.enum_stattype_ice_res_rate', decimal: 2, percent: true, id: 96 },
    electricity_res_rate: { tip: 'tip.name.enum_stattype_electricity_res_rate', decimal: 2, percent: true, id: 97 },
    earth_res_rate: { tip: 'tip.name.enum_stattype_earth_res_rate', decimal: 2, percent: true, id: 99 },
    dark_res_rate: { tip: 'tip.name.enum_stattype_dark_res_rate', decimal: 2, percent: true, id: 100 },
    holy_res_rate: { tip: 'tip.name.enum_stattype_holy_res_rate', decimal: 2, percent: true, id: 101 },
    elements_res_rate: { tip: 'tip.name.enum_stattype_elements_res_rate', decimal: 2, percent: true, id: 102 },
    self_cc_time_rate: { tip: 'tip.name.enum_stattype_self_cc_time_rate', decimal: 2, percent: true, id: 105 },
    enemy_cc_time_rate: { tip: 'tip.name.enum_stattype_enemy_cc_time_rate', decimal: 2, percent: true, id: 106 },
    awakening_dam_rate: { tip: 'tip.name.enum_stattype_awakening_dam_rate', decimal: 2, percent: true, id: 110 },
    item_drop_rate: { tip: 'tip.name.enum_stattype_item_drop_rate', decimal: 2, percent: true, id: 111 },
    gold_rate: { tip: 'tip.name.enum_stattype_gold_rate', decimal: 2, percent: true, id: 112 },
    exp_rate: { tip: 'tip.name.enum_stattype_exp_rate', decimal: 2, percent: true, id: 113 },
    attack_power_addend: { tip: 'tip.name.enum_stattype_attack_power_addend', id: 123 },
    npc_species_humanoid_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_humanoid_dam_rate', decimal: 2, percent: true, id: 125 },
    npc_species_devil_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_devil_dam_rate', decimal: 2, percent: true, id: 126 },
    npc_species_substance_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_substance_dam_rate', decimal: 2, percent: true, id: 127 },
    npc_species_undead_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_undead_dam_rate', decimal: 2, percent: true, id: 128 },
    npc_species_plant_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_plant_dam_rate', decimal: 2, percent: true, id: 129 },
    npc_species_insect_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_insect_dam_rate', decimal: 2, percent: true, id: 130 },
    npc_species_spirit_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_spirit_dam_rate', decimal: 2, percent: true, id: 131 },
    npc_species_wild_beast_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_wild_beast_dam_rate', decimal: 2, percent: true, id: 132 },
    npc_species_mechanic_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_mechanic_dam_rate', decimal: 2, percent: true, id: 133 },
    npc_species_ancient_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_ancient_dam_rate', decimal: 2, percent: true, id: 134 },
    npc_species_god_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_god_dam_rate', decimal: 2, percent: true, id: 135 },
    npc_species_archfiend_dam_rate: { tip: 'tip.name.enum_stattype_npc_species_archfiend_dam_rate', decimal: 2, percent: true, id: 136 },
    vitality: { tip: 'tip.name.enum_stattype_vitality', id: 137 },
    ship_booter_speed: { tip: 'tip.name.enum_stattype_ship_booter_speed', decimal: 1, id: 138 },
    ship_wreck_speed_rate: { tip: 'tip.name.enum_stattype_ship_wreck_speed_rate', decimal: 2, percent: true, id: 139 },
    ship_wreck_spisland_speed_rateeed_rate: { tip: 'tip.name.enum_stattype_island_speed_rate', decimal: 2, percent: true, id: 140 },
    resource_recovery_rate: { tip: 'tip.name.enum_stattype_resource_recovery_rate', decimal: 2, percent: true, id: 149 },
    maxdam: { tip: 'tip.name.enum_stattype_weapon_dam', id: 151 },
  };

  socialStats = {
    charm: { tip: 'sys.characterinfo.tendency_charm' },
    courage: { tip: 'sys.characterinfo.tendency_courage' },
    intellect: { tip: 'sys.characterinfo.tendency_intellect' },
    kindness: { tip: 'sys.characterinfo.tendency_kindness' },
  };
  
  // sys.card.book_effect_desc_damattr
  damageAttr = {
    1: 'tip.name.enum_damageattr_fire',
    2: 'tip.name.enum_damageattr_ice',
    3: 'tip.name.enum_damageattr_electricity',
    5: 'tip.name.enum_damageattr_earth',
    6: 'tip.name.enum_damageattr_dark',
    7: 'tip.name.enum_damageattr_holy',
  };
  
  tripodOptions = {
    100: { count: 1, min: 1, max: 1 },
    101: { count: 2, min: 1, max: 2 },
    102: { count: 3, min: 1, max: 3 },
    103: { count: 3, min: 1, max: 4 },
  };

  itemSlots = {
    head: {type: 'head'},
    shoulders: {type: 'shoulders'},
    torso: {type: 'torso'},
    legs: {type: 'legs'},
    hands: {type: 'hands'},
    weapon: {type: 'weapon'},
    necklace: {type: 'necklace'},
    earring1: {type: 'earring'},
    earring2: {type: 'earring'},
    ring1: {type: 'ring'},
    ring2: {type: 'ring'},
    bracelet: {type: 'bracelet'},
    stone: {type: 'stone'},
  };

  skillTypes = {
    1: 'tip.name.enum_skillbookacquiretype_normal',
    2: 'tip.name.enum_skillbookacquiretype_area',
    3: 'tip.name.enum_skillbookacquiretype_charge',
    4: 'tip.name.enum_skillbookacquiretype_hording',
    5: 'tip.name.enum_skillbookacquiretype_combo',
    6: 'tip.name.enum_skillbookacquiretype_chain',
    11: 'tip.name.enum_skillbookacquiretype_casting',
  };
  skillCategories = {
    0: 'tip.name.enum_identitycategory_none',
    1: 'tip.name.enum_identitycategory_berserker_normal',
    2: 'tip.name.enum_identitycategory_berserker_rush',
    3: 'tip.name.enum_identitycategory_warlord_normal',
    4: 'tip.name.enum_identitycategory_warlord_sky_fall',
    5: 'tip.name.enum_identitycategory_destroyer_normal',
    6: 'tip.name.enum_identitycategory_destroyer_focus',
    7: 'tip.name.enum_identitycategory_destroyer_release',
    8: 'tip.name.enum_identitycategory_battle_master_normal',
    9: 'tip.name.enum_identitycategory_battle_master_bubble',
    10: 'tip.name.enum_identitycategory_infighter_normal',
    11: 'tip.name.enum_identitycategory_infighter_vigor',
    12: 'tip.name.enum_identitycategory_infighter_shock',
    13: 'tip.name.enum_identitycategory_forcemaster_normal',
    14: 'tip.name.enum_identitycategory_forcemaster_soul',
    15: 'tip.name.enum_identitycategory_lance_master_normal',
    16: 'tip.name.enum_identitycategory_lance_master_wild',
    17: 'tip.name.enum_identitycategory_lance_master_focus',
    18: 'tip.name.enum_identitycategory_devil_hunter_normal',
    19: 'tip.name.enum_identitycategory_devil_hunter_pistol',
    20: 'tip.name.enum_identitycategory_devil_hunter_shotgun',
    21: 'tip.name.enum_identitycategory_devil_hunter_rifle',
    22: 'tip.name.enum_identitycategory_blaster_normal',
    23: 'tip.name.enum_identitycategory_blaster_cannon',
    24: 'tip.name.enum_identitycategory_hawkeye_normal',
    25: 'tip.name.enum_identitycategory_hawkeye_summon',
    26: 'tip.name.enum_identitycategory_summoner_normal',
    27: 'tip.name.enum_identitycategory_summoner_ancient',
    28: 'tip.name.enum_identitycategory_arcana_normal',
    29: 'tip.name.enum_identitycategory_arcana_stack',
    30: 'tip.name.enum_identitycategory_arcana_ruin',
    31: 'tip.name.enum_identitycategory_arcana_card',
    32: 'tip.name.enum_identitycategory_bard_normal',
    33: 'tip.name.enum_identitycategory_bard_serenade',
    34: 'tip.name.enum_identitycategory_enum',
    35: 'tip.name.enum_identitycategory_holyknight_normal',
    36: 'tip.name.enum_identitycategory_holyknight_holy',
    37: 'tip.name.enum_identitycategory_holyknight_retribution',
    38: 'tip.name.enum_identitycategory_demonic_normal',
    39: 'tip.name.enum_identitycategory_demonic_capture',
    40: 'tip.name.enum_identitycategory_demonic_demon',
    41: 'tip.name.enum_identitycategory_warlord_lance',
    42: 'tip.name.enum_identitycategory_reaper_normal',
    43: 'tip.name.enum_identitycategory_reaper_dagger',
    44: 'tip.name.enum_identitycategory_reaper_shadow',
    45: 'tip.name.enum_identitycategory_reaper_swoop',
    46: 'tip.name.enum_identitycategory_scouter_scout',
    47: 'tip.name.enum_identitycategory_scouter_drone',
    48: 'tip.name.enum_identitycategory_scouter_hyper_sync',
    49: 'tip.name.enum_identitycategory_scouter_fusion',
    50: 'tip.name.enum_identitycategory_blade_normal',
    51: 'tip.name.enum_identitycategory_elemental_master_normal',
    52: 'tip.name.enum_identitycategory_elemental_master_fire',
    53: 'tip.name.enum_identitycategory_elemental_master_electricity',
    54: 'tip.name.enum_identitycategory_elemental_master_ice',
    55: 'tip.name.enum_identitycategory_yinyangshi_normal',
    56: 'tip.name.enum_identitycategory_yinyangshi_yang',
    57: 'tip.name.enum_identitycategory_yinyangshi_yin',
  };

  gaugeTypes = {
    warlord: {
      0: {tip: 'tip.name.enum_identitygauge_warlord_bubble'},
    },
    battlemaster: {
      1: {tip: 'tip.name.enum_identitygauge_battle_master_bubble'},
    },
    infighter: {
      0: {tip: 'tip.name.enum_identitygauge_infighter_vigor', factor: 100},
      1: {tip: 'tip.name.enum_identitygauge_infighter_shock', factor: 100},
    },
    soulmaster: {
      0: {tip: 'tip.name.enum_identitygauge_forcemaster_energy'},
    },
    scouter: {
      0: {tip: 'tip.name.enum_identitygauge_scouter_battery'},
    },
    hawkeye: {
      0: {tip: 'tip.name.enum_identitygauge_hawk_point', factor: 10},
    },
    summoner: {
      1: {tip: 'tip.name.enum_identitygauge_summoner_ancient_core', factor: 1000},
    },
    elementalmaster: {
      0: {tip: 'tip.name.enum_identitygauge_elemental_master_arcane_gauge'},
    },
  };


  skillDestructionType = [
    'tip.name.enum_partsattackleveltooltip_none',
    'tip.name.enum_partsattackleveltooltip_1',
    'tip.name.enum_partsattackleveltooltip_2',
    'tip.name.enum_partsattackleveltooltip_3',
  ];
  skillImpairmentType = [
    'tip.name.enum_stiffnesstooltiptype_none',
    'tip.name.enum_stiffnesstooltiptype_low',
    'tip.name.enum_stiffnesstooltiptype_normal',
    'tip.name.enum_stiffnesstooltiptype_high',
    'tip.name.enum_stiffnesstooltiptype_higher',
    'tip.name.enum_stiffnesstooltiptype_highest',
  ];
  skillDirectionalType = [
    'tip.name.enum_directionalattacktooltiptype_0',
    'tip.name.enum_directionalattacktooltiptype_1',
    'tip.name.enum_directionalattacktooltiptype_2',
    'tip.name.enum_directionalattacktooltiptype_3',
    'tip.name.enum_directionalattacktooltiptype_4',
    'tip.name.enum_directionalattacktooltiptype_5',
    'tip.name.enum_directionalattacktooltiptype_6',
    'tip.name.enum_directionalattacktooltiptype_7',
  ];
  skillSuperArmorType = [
    'tip.name.enum_superarmortooltiptype_none',
    'tip.name.enum_superarmortooltiptype_sway',
    'tip.name.enum_superarmortooltiptype_hit',
    'tip.name.enum_superarmortooltiptype_hitstate',
  ];

  skillTabs = {
    lancemaster: [
      {
        types: [16],
        name: 'Flurry',
        limit: 8,
        color: 'blue',
      },
      {
        types: [17],
        name: 'Focus',
        limit: 6,
        color: 'red',
      },
    ],
    demonic: [
      {
        types: [38, 39],
        name: 'Normal',
        limit: 8,
        color: 'yellow',
      },
      {
        types: [40],
        name: 'Demon',
        limit: 0,
        color: 'purple',
      },
    ],
    devilhunter: [
      {
        types: [19],
        name: 'Handgun',
        limit: 8,
        color: 'red',
      },
      {
        types: [20],
        name: 'Shotgun',
        limit: 4,
        color: 'blue',
      },
      {
        types: [21],
        name: 'Rifle',
        limit: 4,
        color: 'purple',
        skip: 4,
      },
    ],
    blaster: [
      {
        types: [22],
        name: 'Normal',
        limit: 8,
        color: 'yellow',
      },
      {
        types: [23],
        name: 'Barrage',
        limit: 0,
        color: 'red',
      },
    ],
    scouter: [
      {
        types: [46, 47, 49],
        name: 'Normal',
        limit: 8,
        color: 'yellow',
      },
      {
        types: [48],
        name: 'Sync',
        limit: 0,
        color: 'red',
      },
    ],
    devilhunter_female: [
      {
        types: [19],
        name: 'Handgun',
        limit: 8,
        color: 'red',
      },
      {
        types: [20],
        name: 'Shotgun',
        limit: 4,
        color: 'blue',
      },
      {
        types: [21],
        name: 'Rifle',
        limit: 4,
        color: 'purple',
        skip: 4,
      },
    ],
  };

  skillPoints = [0, 0, 1, 2, 4, 8, 12, 20, 28, 36, 48, 54, 60];
  levelPoints = (() => {
    let prev = 0;
    return [...Array(61)].map((_, i) => {
      if (i > 50) prev += 6;
      else if (i >= 50) prev += 12;
      else if (i >= 47) prev += 10;
      else if (i >= 40) prev += 8;
      else if (i >= 31) prev += 6;
      else if (i >= 11) prev += 5;
      return prev;
    });
  })();

  constructor() {
    this.statsMap = {};
    Object.entries(this.itemStats).forEach(([name, stat], index) => {
      if (!stat.id) {
        stat.id = index - 100;
      } else {
        this.statsMap[stat.id] = name;
      }
    });
  }
}

const Data = new DataClass();

export default Data;

export function _F(string, ...args) {
  return formatHtml(Data.strings[string], ...args);
}
